<template>
  <form class="edyst-form-group sms-editor-container">
    <h3 class="font-normal text-center">
      {{ editMode ? "Update" : "Create" }} SMS Template
    </h3>
    <label for="name">Name</label>
    <input
      id="name"
      ref="templateName"
      v-model.trim="template.name"
      v-validate="'required'"
      type="text"
      class="template-name"
      name="template name"
      placeholder="Enter template name"
      style="margin-top: 0;"
    />
    <small class="err-msg text-red block mt-2">
      {{ veeValidateErrors.first("template name") }}
    </small>
    <label for="sms-text">SMS content</label>
    <textarea
      id="sms-text"
      v-model.trim="template.content.body"
      v-validate="'required'"
      name="sms text"
      class="sms-text"
      maxlength="160"
      placeholder="Enter SMS content"
      style="margin-top: 0;"
    ></textarea>
    <small class="err-msg text-red block mt-2">
      {{ veeValidateErrors.first("sms text") }}
    </small>
    <div
      class="text-sm text-grey-dark"
      :class="{ 'text-red': getWordCount > 150 }"
    >
      Char. count: {{ getWordCount }}/160
    </div>
    <div class="flex items-center justify-end">
      <button
        class="px-4 ml-2 bg-grey-dark text-white font-normal rounded-sm py-2"
        @click.prevent="$emit('discard-sms-modal')"
      >
        Cancel
      </button>
      <button
        class="px-4 ml-2 bg-green text-white font-normal rounded-sm py-2"
        @click.prevent="handleSubmit"
      >
        {{ editMode ? "Update" : "Create" }}
      </button>
    </div>
  </form>
</template>

<script>
import { createTemplate, updateTemplate } from "@/apis/notification/index"

export default {
  props: {
    editTemplateObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      notyConfig: {
        layout: "bottomLeft",
        animation: {
          open: "slideUp",
          close: "fadeOut",
          progressBar: false,
        },
      },
      template: {
        name: "",
        channel_type: 1,
        content: {
          body: "",
          subject: "",
        },
      },
    }
  },
  computed: {
    getWordCount() {
      return (this.template.content && this.template.content.body.length) || 0
    },
    editMode() {
      return !!(this.editTemplateObj && this.editTemplateObj.name)
    },
  },
  created() {
    if (this.editMode) {
      this.template.name = this.editTemplateObj.name
      this.template.content = this.editTemplateObj.content
    }
  },
  mounted() {
    this.$refs.templateName.focus()
  },
  methods: {
    async handleSubmit() {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.$noty.error("Please fix the errors and try again", this.notyConfig)
        return
      }
      if (this.editMode) {
        this.editTemplate()
      } else {
        this.createSMSTemplate()
      }
    },
    createSMSTemplate() {
      createTemplate(this.template)
        .then(() => {
          this.$noty.info(`New SMS template created`, this.notyConfig)
          this.$modal.hide("sms-modal")
          this.$emit("template-created")
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to create SMS template`, this.notyConfig)
        })
    },
    editTemplate() {
      updateTemplate(this.editTemplateObj.id, this.template)
        .then(() => {
          this.$noty.info(`Template updated`, this.notyConfig)
          this.$modal.hide("sms-modal")
          this.$emit("template-created")
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to update template`, this.notyConfig)
        })
    },
  },
}
</script>

<style scoped>
.sms-editor-container {
  padding: 1.5rem;
}

.edyst-form-group .sms-text {
  width: 100%;
  height: 8rem;
}

.edyst-form-group .sms-text,
.edyst-form-group .template-name {
  color: #5c5c5c;
}

.edyst-form-group .sms-text::-webkit-resizer {
  display: none;
}
</style>
